import { PasswordFormValues } from 'types/state';

export const createPasswordFormValues = (): PasswordFormValues => ({
  password: '',
  passwordConfirm: ''
});
